import { ReactComponent as ScanIcon } from '@assets/icons/scan.svg';

import CommonImage from '@/components/CommonImage';

const MoreActionButton = ({ onShowMore, isDisabled }) => (
	<button
		className="button size32 outline mr-2 dropdown-toggle"
		type="button"
		id="menu1"
		disabled={isDisabled}
		onClick={onShowMore}
	>
		More
	</button>
);

const MoreActionHeader = ({ onCloseMore }) => (
	<h5 className="more-action-title d-flex justify-content-between border-bottom">
		<span className="semibold-14 gray_dark_01">More Action</span>
		<span onClick={onCloseMore}>
			<CommonImage src="/icons/close.svg" width={24} height={24} className="cursor-pointer" />
		</span>
	</h5>
);

const MoreActionItem = ({ text, onClick, className }) => (
	<li>
		<span
			className={`regular-14 gray_dark_02 gray-dark-02 d-block px-3 py-2 cursor-pointer ${className}`}
			onClick={onClick}
		>
			{text}
		</span>
	</li>
);

const MoreActionMenu = ({ onCloseMore, actions }) => (
	<ul className="dropdown-menu-bottom shadow-lg pb-4 more-action-dropdown">
		<MoreActionHeader onCloseMore={onCloseMore} />
		{actions.map(({ text, onClick, className }) => (
			<MoreActionItem key={text} text={text} onClick={onClick} className={className} />
		))}
	</ul>
);

const Footer = ({
	scanProps: { onScanWithCamera, isScanWithCamera, onCloseScanWithCamera },
	moreActionsProps: {
		onShowMore,
		onCloseMore,
		isShowMore,
		onOpenLocationModal,
		onDownloadTPSummary,
		onShowTagModal
	},
	onAddToFavourite,
	isDisabled
}) => {
	const actions = [
		{ text: 'Update Location', onClick: onOpenLocationModal, className: 'update-location' },
		{ text: 'Download TP Summary', onClick: onDownloadTPSummary, className: 'tp-summary' },
		{ text: 'Add Tag (Multiple styles)', onClick: onShowTagModal, className: 'add-tag' }
	];

	return (
		<div className="scanner-footer d-flex align-items-center flex-direction-column justify-content-end">
			<div className="scan-with-camera">
				{!isScanWithCamera && (
					<button
						className="button size32 outline mr-2 border-0 bg-transparent"
						onClick={onScanWithCamera}
					>
						<ScanIcon className="mr-1" />
						<span>Scan with camera</span>
					</button>
				)}
			</div>
			<div className="d-flex justify-content-between align-items-center">
				<div className="more-btn option">
					{!isScanWithCamera && (
						<MoreActionButton onShowMore={onShowMore} isDisabled={isDisabled} />
					)}
					{isShowMore && <MoreActionMenu onCloseMore={onCloseMore} actions={actions} />}
				</div>
				{isScanWithCamera ? (
					<button className="button size32" onClick={onCloseScanWithCamera}>
						Done with Scanning
					</button>
				) : (
					<button className="button size32" onClick={onAddToFavourite} disabled={isDisabled}>
						<span className="desktop-version-btn">Add to favourite</span>
						<span className="mobile-version-btn">Add to fav.</span>
					</button>
				)}
			</div>
		</div>
	);
};

export default Footer;
